import { CJEventType } from '@teetsh/app/src/types/event';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import deserializeDateFromServer from '@teetsh/app/src/utils/time/deserializeDateFromServer';
import { serializeItems } from '@teetsh/app/src/queries/serializer';
import startOfMinute from '@teetsh/app/src/utils/time/startOfMinute';
import addMinutes from '@teetsh/app/src/utils/time/addMinutes';
import { defaultToEmptyArray } from '@teetsh/app/src/queries/sequences/serializer';
import {
  CarnetSearchResult,
  CJSeanceSearchResult,
  EDTSearchResult,
  EleveSearchResult,
  EvaluationSearchResult,
} from '@teetsh/app/src/containers/Search/types';

export function deserializeSearchSeance(
  event: any,
  tz: string,
): CJSeanceSearchResult {
  const { competence, goals, domaine, matiere, cycle } = event;
  const eventStart = parseISO(event.start);
  const start = deserializeDateFromServer(eventStart, tz);
  return {
    tag: event.tag,
    flow: event.flow,
    id: event.id,
    classroomName: event.classroomName,
    schoolName: event.schoolName,
    schoolyear: event.schoolyear,
    linkedFichesDePrep: event.linkedFichesDePrep,
    attachments: event.attachments,
    title: event.title,
    type: event.type as CJEventType,
    bo: {
      competence: serializeItems(defaultToEmptyArray(competence)),
      goals: serializeItems(defaultToEmptyArray(goals)),
      domaine: serializeItems(defaultToEmptyArray(domaine)),
      matiere: serializeItems(defaultToEmptyArray(matiere)),
      cycle,
    },
    materials: serializeItems(event.materials),
    customFields: (event.customFields || []).map(customField => ({
      ...customField,
      items: serializeItems(customField.items),
    })),
    url: event.url,
    searchEntityType: event.searchEntityType,
    start: startOfMinute(start),
    end: addMinutes(start, event.lasting),
  };
}

export function deserializeEleve(eleve: any, tz: string): EleveSearchResult {
  let res = eleve;
  if (eleve.birthday) {
    res = {
      ...res,
      birthday: deserializeDateFromServer(parseISO(eleve.birthday), tz),
    };
  }
  return res;
}

export function deserializeCarnet(
  carnet: CarnetSearchResult,
  tz: string,
): CarnetSearchResult {
  return {
    ...carnet,
    evaluations: carnet.evaluations.map(e => ({
      ...e,
      date: e.date && deserializeDateFromServer(parseISO(e.date as any), tz),
    })),
  };
}

export function deserializeEDTSearchResult(result: any): EDTSearchResult {
  return {
    ...result,
    createdAt: parseISO(result.createdAt),
  };
}

export function deserializeEvaluationSearchResult(
  evaluation: any,
  tz,
): EvaluationSearchResult {
  return {
    ...evaluation,
    createdAt: evaluation.createdAt
      ? parseISO(evaluation.createdAt)
      : undefined,

    date:
      evaluation.date &&
      deserializeDateFromServer(parseISO(evaluation.date as any), tz),
  };
}
